import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="column-wide-half" maskId="round-filled-radius-1-stroke-1.5-IconColumnWideHalf"><path d="M2 5.75C2 4.7835 2.7835 4 3.75 4H20.25C21.2165 4 22 4.7835 22 5.75V11.25H2V5.75Z" fill="currentColor"/><path d="M2 12.75V18.25C2 19.2165 2.7835 20 3.75 20H20.25C21.2165 20 22 19.2165 22 18.25V12.75H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideHalf;
